const $ = require("jquery");

import 'semantic-ui-css';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/widgets/slider';
import 'semantic-ui-transition';
import 'ion-rangeslider';
import 'ion-rangeslider/css/ion.rangeSlider.css';
import {Notify} from "./utils/notify";
import {default as jqueryI18next} from 'jquery-i18next/dist/es/index';
import i18next from "i18next";
import {sendDeleteRequest} from './utils/apiv4helper';

const zxcvbn = require('zxcvbn');
const i18n = require("i18next");
const slider = [];

require("./../translations/datatables/de.json");
require("./../translations/datatables/en.json");
require("./../translations/datatables/fi.json");
require("./../translations/datatables/fr.json");

require("./utils/main");

$(document).ready(
    function() {
        virtaInit();
    }
);

function virtaInit() {

    // Used to show the user that the entered custom evse id is already in use
    $.fn.form.settings.rules.uniqueEvseId = function (value) {
        return (window.lastInvalidCustomEvse || null) !== value;
    };

    // TODO: Check seller’s user password policy after it is implemented
    $.fn.form.settings.rules.passwordPolicyAdmin = function(password) {
        const max_length = 70;
        const min_length = 12;
        const passwordLength = password.length;

        /**
         * Password Estimator class (Zxcvbn) returns a score between 0-4 for how much the password is guessable
         * 0 -> too guessable
         * 1 -> very guessable
         * 2 -> somewhat guessable
         * 3 -> safely unguessable
         * 4 -> very unguessable
         */
        const passwordScore = zxcvbn(password).score;

        return passwordLength <= max_length && passwordLength >= min_length && passwordScore >= 3;
    };

    // some settings requires i18n to finish initialization first
    // this functions put all the settings together and load after i18n initializes
    function loadSettingsAfterI18nInit() {

        //TODO: These probably should not be in main.js???
        $('#change-password-form form').form({
            on: 'blur',
            inline: true,
            fields: {
                currentPass: {
                    identifier  : 'current-pass',
                    rules: [
                        {
                            type   : 'empty',
                            prompt : i18n.t("profile.currentPasswordEmpty")
                        }
                    ]
                },
                newPass: {
                    identifier  : 'new-pass',
                    rules: [
                        {
                            type   : 'empty',
                            prompt : i18n.t("profile.newPasswordEmpty")
                        },
                        {
                            type: 'passwordPolicyAdmin',
                            prompt : i18n.t("profile.passwordEstimatorError")
                        }
                    ]
                },
                newPassConfirm: {
                    identifier  : 'new-pass-confirm',
                    rules: [
                        {
                            type   : 'empty',
                            prompt : i18n.t("profile.newPasswordConfirmEmpty")
                        },
                        {
                            type: 'match[new-pass]',
                            prompt : i18n.t("profile.confirmPassNotMatch")
                        }
                    ]
                },
            }
        });

        $('#new-user-form').form({
            on: 'blur',
            inline: true,
            fields: {
                newPass: {
                    identifier  : 'password',
                    rules: [
                        {
                            type   : 'empty',
                            prompt : i18n.t("profile.newPasswordEmpty")
                        },
                        {
                            type: 'passwordPolicyAdmin',
                            prompt : i18n.t("profile.passwordEstimatorError")
                        }
                    ]
                },
                newPassConfirm: {
                    identifier  : 'confirm_password',
                    rules: [
                        {
                            type   : 'empty',
                            prompt : i18n.t("profile.newPasswordConfirmEmpty")
                        },
                        {
                            type: 'match[password]',
                            prompt : i18n.t("profile.confirmPassNotMatch")
                        }
                    ]
                },
            }
        });
    }

    const lang = ($("#pageLang").val()).substring(0, 2);
    window.lang = lang;
    window.datepickerDateFormat = 'DD.MM.YYYY';
    window.datatableDateFormat = 'DD.MM.YYYY';
    window.datatableDateTimeFormat = 'DD.MM.YYYY HH:mm:ss';

    //Initialize translations etc
    const resBundle = require(
        "i18next-resource-store-loader!../../locales/index.js"
    );

    i18n.init({
        whitelist: ["en", "de", "fi", "fr", "sv"],
        lng: lang,
        fallbackLng: 'en',
        debug: true,
        resources: resBundle,
        interpolation: {
            prefix: "__",
            suffix: "__"
        }
    }, function() {
        jqueryI18next.init(i18n, $, {
            useOptionsAttr: true,
            i18nName: 'i18n'
        });

        $("body").localize();

        setTimeout(loadSettingsAfterI18nInit, 450);
        window.langtext = getPromptText();
    });

    // Load virta nav
    const $brand = $('.virta.menu .virta-brand'),
        $sandwich = $('.virta.menu .nav-sandwich'),
        $menu = $('.virta-menu:not(.virta-menu-fixed)'),
        $fixedMenu = $('.virta-menu-fixed'),
        $collapsedMenu = $('#virta-menu'),
        // totalWidth = parseInt($brand.outerWidth() + $menu.outerWidth() + $fixedMenu.outerWidth(), 10),
        totalWidth = parseInt($brand.outerWidth() + $menu.width() + $fixedMenu.outerWidth(), 10);
    let collapsed = false;

    $collapsedMenu.sidebar('setting', {
        dimPage: true,
        transition: 'overlay',
        mobileTransition: 'overlay',
        onVisible: function () {
            $('body').css('overflow-y', 'hidden');
        },
        onHide: function () {
            $('body').css('overflow-y', 'auto');
        }
    });

    const menuCollapse = function () {
        const calculatedHeight = $(window).height() - $('.virta.menu').height(); // FIXME: Ugly height calculation for sidebar to compensate top nav height
        $collapsedMenu.attr('style', 'height: ' + calculatedHeight + 'px !important');
        let $items;

        // console.log('brand', 'inner', $brand.width(), 'outer', $brand.outerWidth());
        // console.log('menu', 'inner', $menu.width(), 'outer', $menu.outerWidth());
        // console.log('fixed', 'inner', $fixedMenu.width(), 'outer', $fixedMenu.outerWidth());
        // console.log('window', $(window).width(), 'total', totalWidth);

        if ($(window).width() < totalWidth || $(window).width() <= 1340) {
            if (!collapsed) {
                $items = $menu.find('.item');

                $items.each(function () {
                    const $item = $(this);
                    if (!$item.hasClass('browse')) {
                        $item.appendTo($collapsedMenu);
                    } else {
                        const section = $item.data('section');
                        const $browseItems = $item.next('.popup').find('.item');
                        $item.appendTo($collapsedMenu);
                        $browseItems.addClass('browse-item').data('section', section).appendTo($collapsedMenu);
                    }
                });

                $collapsedMenu.find('.browse.item').css('display', 'none');

                if (!$brand.hasClass('virta-brand-center')) {
                    $brand.addClass('virta-brand-center');
                }

                if ($sandwich.hasClass('hidden')) {
                    $sandwich.removeClass('hidden');
                }

                collapsed = true;
            }
        } else {
            if (collapsed) {
                if ($collapsedMenu.sidebar('is visible')) {
                    $collapsedMenu.sidebar('hide');
                }

                $items = $collapsedMenu.find('.item');

                $items.each(function () {
                    const $item = $(this);

                    if (!$item.hasClass('browse-item')) {
                        $item.appendTo($menu);
                    } else {
                        const section = $item.data('section');
                        const $browseItem = $menu.find('.browse.item[data-section="' + section + '"]');
                        $browseItem.appendTo($menu);

                        const $popup = $menu.find('.popup[data-section="' + section + '"]');
                        $browseItem.after($popup);

                        const $itemsMenu = $browseItem.next('.popup').find('.ui.list');
                        $item.appendTo($itemsMenu);
                    }
                });

                if ($brand.hasClass('virta-brand-center')) {
                    $brand.removeClass('virta-brand-center');
                }

                $menu.find('.browse.item').css('display', 'flex');

                $menu.show();
                loadPopup();

                if (!$sandwich.hasClass('hidden')) {
                    $sandwich.addClass('hidden');
                }

                collapsed = false;
            }
        }
    };

    menuCollapse();

    $(window).on('resize', function () {
        menuCollapse();
    });

    $sandwich.on('click', 'i.icon', function () {
        if ($collapsedMenu.sidebar('is hidden')) {
            $collapsedMenu.sidebar('show')
        } else {
            $collapsedMenu.sidebar('hide');
        }
    });

    function loadPopup() {
        $('.browse').popup({
            on: 'click',
            transition: 'slide down',
            inline   : true,
            hoverable: true,
            position : 'bottom left',
            delay: {
                show: 300,
                hide: 400
            }
        });
    }

    $('.ui.dropdown').dropdown({
        message: {
            noResults: ""
        }
    });

    const $sliderElement = $('.js-range');

    $sliderElement.each(function(index, elem) {
        const elemSlider = $(elem).ionRangeSlider({
            hide_min_max: true,
            hide_from_to: true,
            onChange: function (data) {
                $(data.slider.closest('.field').find('.range-value').text(data.from));
            }
        });
        slider.push(elemSlider.data('ionRangeSlider'));
    });

    $(".navbar-btn").on('click', function() {
        $(this).closest('div').find('.btn').removeClass('btn-active').addClass('btn-nav');
        $(this).removeClass('btn-nav').addClass('btn-active');
    });

    $(".dropdown-menu a").on('click', function() {
        $(this).closest('.dropdown').find('button > .val').text( $(this).text() );
        const value = $(this).attr('data-value');
        $(this).closest('.dropdown').find('input').val( $(this).attr('data-value') ).trigger('change');

    });

    $('a.item').click(function(){
        $('.item.active').removeClass("active");
        $(this).addClass("active");
    });

    $('.ui.accordion').accordion();

    $('#lang').click(function(){

        $('#language-menu').sidebar('setting', {
            dimPage: false,
            transition: 'overlay',
            mobileTransition: 'overlay'
        }).sidebar('show');
    });

    loadPopup();

    $('i.icon.write.noarchives').click(function(event){
        event.preventDefault();
        const parentId = $(this).data('content');
        $(parentId).find('.field, .show-map, .configuration, .update-firmware, .get-diagnostics, .fetch-diagnostics-list').removeClass('disabled');
        $(parentId).find(".version, .station-controls, .station-options, .station-move").fadeIn();
        $('.reset-password, .remove').fadeIn();
        $('.login-credentials .item').css("border", "1px solid #CCC");
        $(".content .actions").fadeIn();
        $.map(slider, function(i, val) {
            i.update({
                disable: false
            });
        });
        $(this).addClass('disabled');
    });

    $('.station-list i.icon.write.archives').click(function(event){
        event.preventDefault();
        const parentId = $(this).data('content');
        $(parentId).find(".version, .station-controls, .station-options, .station-move").fadeIn();
        $('.station-save').hide();
        $(this).addClass('disabled');
    });

    $('.content .actions').click(function(event){
        $('.content .actions').fadeOut();
        $('.stations input').closest('.field').addClass('disabled');
        $('.reset-password, .remove').fadeOut();
        $('.login-credentials .item').css("border", "none");
        $('.dropdown').addClass("disabled");
        event.preventDefault();
    });

    $('.station-cancel').click(function(event){
        event.preventDefault();
        const form = $(this).parents().closest('form');
        const parentId = $(this).data('content');

        form.find(".error").removeClass("error");
        form.find("span[id$='-error']").hide();

        $.map(slider, function(i, val) {
            i.update({
                disable: true
            });
        });

        $(parentId).find('.version, .station-controls, .station-options, .station-move, .show-map').fadeOut();
        $(parentId).find('.field, .show-map, .configuration, .update-firmware, .get-diagnostics').addClass('disabled');
        $(parentId).find('.noarchives').removeClass('disabled');
        $(parentId).find('.archives').removeClass('disabled');
        $(parentId).find('input[name=station-move]').prop('checked', false);
        $(parentId).find('.pool-relate-item').attr('disabled', 'disabled').addClass('disabled');

        $('.reset-password, .remove').fadeOut();
        $('.login-credentials .item').css("border", "none");
    });

    $('.login-credentials .close').click(function(){
        $(this).parent().parent().fadeOut();
    });

    $('.ui.slider').slider();

    $('.customers .tabular .item').tab();

    $('#station-map .tabular .item').tab();

    $('.close-station').click(function() {
        $('.station-location').removeClass('active');
        $('.station-details').animate({width: 0, marginLeft: 0}, {duration: 400});
        $('.overlap').animate({ marginLeft: 1103}, {duration: 400});
    });

    $('.station-location').click(function() {
        $('.station-location').removeClass('active');
        $(this).addClass('active');
        $('.station-details').animate({width: 951, marginLeft: 0}, {duration: 400});
        $('.overlap').animate({ marginLeft: 150}, {duration: 400});
    });

    $('#nap-account-form').on('submit', function(e) {
        e.preventDefault();
        const form = $(this);
        const formData = form.serializeArray();
        formData.push({name: "action", value: "registerNAPAccount"});
        $.ajax({
            url: '/async.php',
            method: 'POST',
            dataType: 'json',
            data: formData,
            success: function (data) {
                const success = data.success;
                const messages = data.messages;
                // Handle errors
                if(!success) {
                    for(let i = 0; i < messages.length; i++){
                        Notify.error(messages[i]);
                    }
                    return false;
                }
                $('.ui.modal.show-modal-nap-account').modal('hide');
                form.form('reset');
                Notify.success(messages[0]);
            }
        });
    });

    handleLogout();
    showNAPPopup(true); // always show
    showNAPTier3Popup(true); // always show
    handleShowNapPopup();
}

function alertSemantic(message) {
    const template = '<div class="ui modal alert-modal">' +
        '<i class="close icon"></i>' +
        '<div class="header">' +
        '<h3>Alert</h3>' +
        '</div>' +
        '<div class="content">' + message + '</div>' +
        '<div class="actions">' +
        '<div class="ui button cancel button green small">OK</div>' +
        '</div>' +
        '</div>';

    $('body').append(template);
    const $modal = $('.ui.modal.alert-modal');
    $modal.modal({
        onHidden: function() {
            $modal.remove();
        }
    }).modal('show');
}

function isMobileDevice() {
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4));
}

function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    let results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function navigateToStation(stationId) {
    window.location.href = '/stations.php?station=' + stationId;
}

function handleLogout() {
    const $logOutButton = $('#logoutBtn');
    $logOutButton.click((e) => {
        e.preventDefault();
        const path = '/admin/auth';

        sendDeleteRequest(path, true)
            .always(() => {
                localStorage.removeItem('v4token');
                window.location.href = '/logout.php';
            });
    });
}

function handleShowNapPopup() {
    const $popupButton = $('#napAccountBtn');
    $.ajax({
        url: '/async.php',
        type: 'post',
        data: {
            'action': 'checkIfShouldDisplayNAPPopup'
        },
        dataType: 'JSON',
        success: function(data) {
            if (data.show_popup === true || data.show_popup_force === true) {
                $popupButton.removeClass('hidden').addClass('visible');
                $popupButton.click((e) => {
                    e.preventDefault();
                    $popupButton.removeClass('active');
                    showNAPPopup(true);
                });
            }
        }
    })
}

function showNAPPopup(alwaysShow = false) {
    //only display the popup once per user session by default, and then when opened from the button
    if (alwaysShow === false && localStorage.getItem('NAPPopupDisplayed') === 'true' && getParameterByName("lang") === null) {
        return;
    }
    $.ajax({
        url: '/async.php',
        type: 'post',
        data: {
            'action': 'checkIfShouldDisplayNAPPopup'
        },
        dataType: 'JSON',
        success: function(data) {
            if (data.show_popup === true || data.show_popup_force === true) {
                const $modal = $('.show-modal-nap-account');
                const organisation = $('#nap-account-form').find('[name=seller]').val();
                const virtaHub = '<a href="http://hub.virta.global/" target="_blank">Virta Hub</a>';
                const faq = '<a href="https://support.virta.global/hc/en-gb/articles/16169074486173-FAQ-Transitioning-From-Virta-Admin-Panel-To-Virta-Hub" target="_blank">FAQ</a>';
                const sharePoint = '<a href="https://liikennevirta.sharepoint.com/:w:/s/VirtaAllEmployees/EfJWAulOVvdPoscs_h0Z280BWKm7W_-BNFDqOO5tohvaFw?e=ytOpU6" target="_blank">' + `${i18next.t('napAccount.here')}` + '</a>';

                let title, message1, message2, message3, letsJourney;
                if (data.show_popup_force === true) {
                    title = `${i18next.t('napAccount.welcome', {'hub': virtaHub, 'interpolation': {'escapeValue': false}})}`;
                    message1 = `${i18next.t('napAccount.yourOrganisationUpgradedForce', {'organisation': organisation, 'hub': virtaHub, 'interpolation': {'escapeValue': false}})}`;
                    letsJourney = `${i18next.t('napAccount.letsStartYourJourney', {'hub': virtaHub, 'interpolation': {'escapeValue': false}})}`;
                    const faqMsg = `${i18next.t('napAccount.pleaseReferToFAQ', {'faq': faq, 'interpolation': {'escapeValue': false}})}`;
                    $modal.find('#napPopupFAQ').html(faqMsg);
                    $modal.find('#letsStartYourJourney').html(letsJourney);
                } else {
                    title = `${i18next.t('napAccount.welcome', {'hub': virtaHub, 'interpolation': {'escapeValue': false}})}`;
                    message1 = `${i18next.t('napAccount.yourOrganisationUpgraded', {'organisation': organisation, 'hub': virtaHub, 'interpolation': {'escapeValue': false}})}`;
                    message2 = `${i18next.t('napAccount.giveCredentialForOthers', {'sharepoint': sharePoint, 'interpolation': {'escapeValue': false}})}`;
                    message3 = `${i18next.t('napAccount.adventureBegins', {'hub': virtaHub, 'interpolation': {'escapeValue': false}})}`;
                    $modal.find('#additionalMembers').html(message2);
                }

                $modal.find('#title').html(title);
                $modal.find('#organisationUpgraded').html(message1);
                $modal.modal('attach events', '.button.close', 'close');
                $modal.find('#adventureBegins').html(message3);
                $modal.modal({
                    onApprove: function () {
                        $('#nap-account-form').submit();
                        return false;
                    },
                    onDeny: function () {
                        $.ajax({
                            url: '/async.php',
                            type: 'post',
                            data: {
                                'action': 'saveUserClaimsHasNAPAccount'
                            },
                            dataType: 'JSON',
                        })
                    }
                }).modal('show');
                localStorage.setItem('NAPPopupDisplayed', 'true');
            }
        }
    })
}

function showNAPTier3Popup(alwaysShow = false) {
    // only display the popup once per user session by default, and then when opened from the button
    if (alwaysShow === false && localStorage.getItem('NAPTier3PopupDisplayed') === 'true' && getParameterByName("lang") === null) {
        return;
    }
    $.ajax({
        url: '/async.php',
        type: 'post',
        data: {
            'action': 'checkIfShouldDisplayNAPPopup'
        },
        dataType: 'JSON',
        success: function(data) {
            if (data.show_tier3_popup === true) {
                const $modal = $('.show-modal-nap-account-tier3');
                const virtaHub = '<b><a href="http://hub.virta.global/" target="_blank">Virta Hub</a></b>';
                const addTeamMemberGuide = "https://support.virta.global/hc/en-gb/articles/10897856303773-3-1-How-to-add-members-to-your-management-team-Essential";
                const knowledgeBaseLink = "https://support.virta.global/hc/en-gb";
                const faqLink = "https://support.virta.global/hc/en-gb/articles/16169074486173-FAQ-Transitioning-From-Virta-Admin-Panel-To-Virta-Hub";

                const paragraph1 = `${i18next.t('napAccountTier3Popup.yourOrganisationUpgraded', {'hub': virtaHub, 'interpolation': {'escapeValue': false}})}`;
                const paragraph2 = `${i18next.t('napAccountTier3Popup.platformNoLongerAvailable', {'interpolation': {'escapeValue': false}})}`;
                const missingPermission = `${i18next.t('napAccountTier3Popup.missingPermission', {'interpolation': {'escapeValue': false}})}`;
                const addingMoreTeamMembers = `${i18next.t('napAccountTier3Popup.addingMoreTeamMembers', {'add_team_member_guide': addTeamMemberGuide,'interpolation': {'escapeValue': false}})}`;
                const loginAndExplore = `${i18next.t('napAccountTier3Popup.loginAndExplore', {'hub': virtaHub, 'interpolation': {'escapeValue': false}})}`;
                $modal.find('#tier3_popup_yourOrganisationUpgraded').html(paragraph1);
                $modal.find('#tier3_popup_platformNoLongerAvailable').html(paragraph2);
                $modal.find('#tier3_popup_missingPermission').html(missingPermission);
                $modal.find('#tier3_popup_loginAndExplore').html(loginAndExplore);
                $modal.find('#tier3_popup_addingMoreTeamMembers').html(addingMoreTeamMembers);

                const moreDetails = `${i18next.t('napAccountTier3Popup.moreDetailsKnowledgeBaseFAQ', {
                    'add_team_member_guide': addTeamMemberGuide,'interpolation': {'escapeValue': false},
                    'knowledge_base': knowledgeBaseLink, 'faq': faqLink
                })}`;
                $modal.find('#tier3_popup_moreDetailsKnowledgeBaseFAQ').html(moreDetails);

                $modal.modal('attach events', '.button.close', 'close');
                $modal.modal({
                    onApprove: function () {
                        $('#nap-account-form').submit();
                        return false;
                    },
                    onDeny: function () {
                        $.ajax({
                            url: '/async.php',
                            type: 'post',
                            data: {
                                'action': 'saveUserClaimsHasNAPAccount'
                            },
                            dataType: 'JSON',
                        })
                    }
                }).modal('show');
                localStorage.setItem('NAPTier3PopupDisplayed', 'true');
            }
        }
    })
}


export {
    alertSemantic,
    getParameterByName,
    navigateToStation,
    isMobileDevice,
    virtaInit
};

function getPromptText()
{

    var langtext = {
        unspecifiedRule         : i18n.t("jserror.text.unspecifiedRule"),
        unspecifiedField        : i18n.t("jserror.text.unspecifiedField"),
        empty                   : i18n.t("jserror.prompt.empty"),
        checked                 : i18n.t("jserror.prompt.checked"),
        email                   : i18n.t("jserror.prompt.email"),
        phonex                  : i18n.t("jserror.prompt.phonex"),
        url                     : i18n.t("jserror.prompt.url"),
        regExp                  : i18n.t("jserror.prompt.regExp"),
        integer                 : i18n.t("jserror.prompt.integer"),
        decimal                 : i18n.t("jserror.prompt.decimal"),
        number                  : i18n.t("jserror.prompt.number"),
        is                      : i18n.t("jserror.prompt.is"),
        isExactly               : i18n.t("jserror.prompt.isExactly"),
        not                     : i18n.t("jserror.prompt.not"),
        notExactly              : i18n.t("jserror.prompt.notExactly"),
        contain                 : i18n.t("jserror.prompt.contain"),
        containExactly          : i18n.t("jserror.prompt.containExactly"),
        doesntContain           : i18n.t("jserror.prompt.doesntContain"),
        doesntContainExactly    : i18n.t("jserror.prompt.doesntContainExactly"),
        minLength               : i18n.t("jserror.prompt.minLength"),
        length                  : i18n.t("jserror.prompt.length"),
        exactLength             : i18n.t("jserror.prompt.exactLength"),
        maxLength               : i18n.t("jserror.prompt.maxLength"),
        match                   : i18n.t("jserror.prompt.match"),
        different               : i18n.t("jserror.prompt.different"),
        creditCard              : i18n.t("jserror.prompt.creditCard"),
        bicCode                 : i18n.t("jserror.prompt.bicCode"),
        ibanCode                : i18n.t("jserror.prompt.ibanCode"),
        minCount                : i18n.t("jserror.prompt.minCount"),
        exactCount              : i18n.t("jserror.prompt.exactCount"),
        maxCount                : i18n.t("jserror.prompt.maxCount"),
        between                 : i18n.t("jserror.prompt.between")
    };

    return langtext;
}
